import { Icon } from '@vrplatform/icons';
import {
  EllipsisMenuCopyItem,
  EllipsisMenuDangerItem,
  EllipsisMenuDivider,
  EllipsisMenuItem,
} from '@vrplatform/components-legacy';
import { Box, Tooltip } from '@mantine/core';
import {
  EllipsisMenuAuditEffectsItem,
  HiddenFeatureIndicator,
} from '../../components';
import { useJournalEntriesModal } from '../../modals';

export const BankTransferEllipsisMenuItems = ({
  bankTransfer,
  openDeleteModal,
  openEditModal,
  openUnmatchModal,
}: {
  bankTransfer: {
    id: string;
    isReconciled: boolean;
    isPublished: boolean;
    lock?: {
      status?: string | null;
    } | null;
  };
  openDeleteModal: () => void;
  openEditModal: () => void;
  openUnmatchModal: () => void;
}) => {
  const { open: openJournalEntriesModal } = useJournalEntriesModal();
  const lockStatus = bankTransfer.lock?.status;
  const isLocked = lockStatus === 'locked';
  const editDisabled =
    bankTransfer.isReconciled || bankTransfer.isPublished || isLocked;

  return (
    <>
      {bankTransfer.isReconciled && (
        <>
          <EllipsisMenuItem
            onClick={openUnmatchModal}
            customIcon={<Icon icon="CrossCircleIcon" size={16} />}
          >
            Unmatch
          </EllipsisMenuItem>

          <EllipsisMenuDivider />
        </>
      )}

      <Tooltip
        label={
          isLocked
            ? 'This bank transfer is locked and cannot be edited.'
            : bankTransfer.isPublished
              ? 'This bank transfer is related to a published owner statement. To edit it, move the related owner statements back to draft.'
              : 'This bank transfer was matched and cannot be edited.'
        }
        multiline
        maw={400}
        position="left"
        disabled={!editDisabled}
      >
        <Box>
          <EllipsisMenuItem
            customIcon={<Icon icon="Edit3Icon" size={16} />}
            onClick={openEditModal}
            disabled={editDisabled}
          >
            Edit
          </EllipsisMenuItem>
        </Box>
      </Tooltip>

      <EllipsisMenuItem
        customIcon={<Icon icon="ListUnorderedIcon" size={16} />}
        onClick={() =>
          openJournalEntriesModal({
            transactionIds: [bankTransfer.id],
          })
        }
      >
        Journal Entries
      </EllipsisMenuItem>

      <EllipsisMenuDivider />

      <Tooltip
        label="Please unmatch the bank transfer before deleting."
        disabled={!bankTransfer.isReconciled}
      >
        <Box>
          <EllipsisMenuDangerItem
            onClick={openDeleteModal}
            disabled={bankTransfer.isReconciled}
          >
            Delete
          </EllipsisMenuDangerItem>
        </Box>
      </Tooltip>

      <HiddenFeatureIndicator permission="vrp-admin">
        <EllipsisMenuAuditEffectsItem entityId={bankTransfer.id} />
        <EllipsisMenuCopyItem value={bankTransfer.id} />
      </HiddenFeatureIndicator>
    </>
  );
};
